import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';
import { useRolePermissions } from '../context/RolePermissionsContext';
import { selectRequesterIdentityReady } from '../app/userInfoSlice';
import { isDnbIdentitySearchTenant } from '../config/dnbIdentitySearchRollout';
import DnbIdentitySearchDialog from './DnbIdentitySearchDialog';
import DnbIdentityBatchDialog from './DnbIdentityBatchDialog';

export default function DnbIdentitySearchLauncher({ tenantId }) {
  const { user, isAuthenticated, isLoading } = useAuth0();
  const isAdmin = useSelector(state => state.userInfo.isAdmin);
  const identityReady = useSelector(state => selectRequesterIdentityReady(state, user?.sub));
  const { loading, isSupportPreview, permissions } = useRolePermissions();
  const allowed = isDnbIdentitySearchTenant(tenantId) && isAdmin === true && identityReady &&
    isAuthenticated === true && !isLoading && !loading && !isSupportPreview && permissions?.isViewOnly !== true;
  return <><DnbIdentitySearchDialog tenantId={tenantId} requesterId={user?.sub} allowed={allowed} /><DnbIdentityBatchDialog tenantId={tenantId} requesterId={user?.sub} allowed={allowed} /></>;
}
